import React from "react";
import { CloseIcon } from "icons/close/CloseIcon";
import { SuccessPaymentIcon } from "icons/payments/successPayment";
import { useTid } from "utils/testid";

interface SuccessDefaultPaymentProps {
  paymentScheduleId: string;
  onClose: () => void;
  onViewDetails: () => void;
  onNavigateDashboard: () => void;
}

const SuccessDefaultPayment: React.FC<SuccessDefaultPaymentProps> = ({
  paymentScheduleId,
  onClose,
  onViewDetails,
  onNavigateDashboard,
}) => {
  const tid = useTid();

  return (
    <div
      className="w-full h-full"
      data-testid={tid("update-plan-success-default")}
      aria-label="Payment plan updated successfully"
    >
      <div className="flex justify-end">
        <div
          onClick={() => onClose()}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onClose();
            }
          }}
          className="cursor-pointer p-2 rounded-full hover:!bg-bgSecondary"
          role="button"
          tabIndex={0}
          data-testid={tid("update-plan-success-close-button")}
          aria-label="Close successful payment plan update"
        >
          <CloseIcon aria-hidden="true" />
        </div>
      </div>
      <div className="lg:px-0 px-5 grid place-items-center">
        <div className="flex flex-col justify-center items-center max-w-[630px] mt-[25%]">
          <SuccessPaymentIcon aria-hidden="true" />
          <p
            className="lg:text-2xl text-xl text-txtPrimary font-medium mt-10"
            data-testid={tid("update-plan-success-title")}
          >
            Payment plan updated successfully
          </p>
          <p className="lg:text-base text-sm font-normal text-txtParagraph mt-[16px]">
            Your payment plan has been successfully updated.
          </p>

          <p className="lg:text-base text-sm font-normal text-txtParagraph mt-10">
            <span
              className="text-btnPrimaryActive hover:!text-btnPrimaryHover  underline cursor-pointer"
              onClick={onViewDetails}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onViewDetails();
                }
              }}
              role="button"
              tabIndex={0}
              data-testid={tid("update-plan-success-view-details-link")}
              aria-label="View full plan details"
            >
              Click here
            </span>{" "}
            to view your full plan details.
          </p>
          <p
            className="text-btnPrimaryActive lg:text-base text-sm font-medium mt-10 cursor-pointer hover:!text-btnPrimaryHover "
            onClick={onNavigateDashboard}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onNavigateDashboard();
              }
            }}
            role="button"
            tabIndex={0}
            data-testid={tid("update-plan-success-dashboard-link")}
            aria-label="Back to dashboard"
          >
            Back to dashboard
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessDefaultPayment;
